/** @jsxImportSource @emotion/react */
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useMount } from 'react-use';
import { IllustrationWithText } from 'components';
import { useOrder } from 'context';
import { inIframe } from 'utils';

const SECONDS = 2;

export const Cancelled = () => {
  const { formatMessage } = useIntl();
  const { failureRedirectUrl } = useOrder();
  const [seconds, setSeconds] = useState(SECONDS);

  useMount(() => {
    sessionStorage.clear();
    if (failureRedirectUrl) {
      setTimeout(() => {
        const windowLocation = inIframe()
          ? window.parent.location
          : window.location;
        windowLocation.replace(failureRedirectUrl);
      }, SECONDS * 1000);
    }
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <IllustrationWithText
      illustration="unplugged"
      heading={formatMessage({ id: 'page.cancelled.heading' })}
      subheading={
        failureRedirectUrl
          ? formatMessage({ id: 'redirect.backToMerchant' }, { seconds })
          : formatMessage({ id: 'page.cancelled.subHeading' })
      }
    />
  );
};
